// Remembers which tab (Published/Draft) the Simulation Cases page should open
// to next — the page always defaults to Published unless the user was just
// on a draft (viewing one, or just created one), in which case it should
// reopen to Draft. Read-and-clear on load so it only affects that one next
// visit, not indefinitely.
const KEY = 'kabilah_last_cases_tab';

export function setLastCasesTab(tab) {
  try {
    sessionStorage.setItem(KEY, tab);
  } catch {
    // Best-effort — worst case the page just opens to Published.
  }
}

// Split into a pure read + a separate clear, rather than one read-and-clear
// function, because the read happens inside a useState lazy initializer.
// React 18 StrictMode double-invokes initializers in development to surface
// exactly this kind of bug: a combined read-and-clear would consume the flag
// on the first (discarded) call, so the second call — the one that actually
// determines the initial state — would always see it already cleared and
// silently fall back to the default tab.
export function peekLastCasesTab() {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearLastCasesTab() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Best-effort — worst case the flag lingers and affects one extra visit.
  }
}
